<div class="p-3 background">
    <div class="d-flex justify-content-center align-items-center vh-100">
    <div class="card p-4 card" style="max-width: 600px; width: 100%;">
      <div class="row">
        <h3 class="col">Admin prijava</h3>
      </div>
      <form [formGroup]="loginFormGroup">
        <label class="ms-4 mb-2" for="adminUsernameInput">Uporabniško ime</label>
        <div class="d-flex align-items-center">
          <fa-icon class="me-3 mb-2" [icon]="faUser"></fa-icon>
          <input id="adminUsernameInput" class="form-control mb-2" type="text" formControlName="username" placeholder="Uporabniško ime" />
        </div>
        <label class="ms-4 mb-2" for="passwordInput">Geslo</label>
        <div class="d-flex align-items-center">
          <fa-icon class="me-3 mb-2" [icon]="faLock"></fa-icon>
          <input id="adminPasswordInput" class="form-control mb-2" type="password" formControlName="password" placeholder="Geslo" (keyup.enter)="OnEnterPressed()" />
        </div>
          <button id="sendButton" type="button" class="btn btn-primary" (click)="OnLoginPressed()" [disabled]="!loginFormGroup.valid || isLoggingIn">
          {{isLoggingIn ? 'Prijavljam se ...' : 'Prijavi se'}}
        </button>
      </form>
    </div>
 </div>
</div>
  